/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import Item, { type SwitcherItemProps } from './item';
import { token } from '@atlaskit/tokens';
import { css, jsx } from '@compiled/react';
import * as colors from '@atlaskit/theme/colors';
import { useIsSwitcherTeam25TestCohort } from '../components/experiment-provider';

const childItemStyles = css({
	paddingTop: token('space.050', '4px'),
	paddingRight: token('space.100', '8px'),
	paddingBottom: token('space.050', '4px'),
	paddingLeft: token('space.100', '8px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	background: `${token('elevation.surface.sunken', colors.N20)} `,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: `${token('color.text', colors.N900)} `,
	textDecoration: 'none',
	'&:hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		background: `${token('color.background.neutral.hovered', colors.N30)} `,
	},
	'&:active': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		background: `${token('color.background.neutral.pressed', colors.N20)} `,
	},
});

const refreshedChildItemStyles = css({
	paddingTop: token('space.050', '4px'),
	paddingRight: token('space.100', '8px'),
	paddingBottom: token('space.050', '4px'),
	paddingLeft: token('space.100', '8px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	'&:hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		background: `${token('color.background.neutral.subtle.hovered')} `,
	},
	'&:active': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		background: `${token('color.background.neutral.subtle.pressed')} `,
	},
});

const iconStyles = css({
	marginRight: `${token('space.negative.050', '-4px')}`,
});

export default (props: SwitcherItemProps) => {
	const { icon, ...rest } = props;
	const isVisualRefreshEnabled = useIsSwitcherTeam25TestCohort();

	return (
		<Item
			icon={<span css={iconStyles}>{icon}</span>}
			{...rest}
			css={[isVisualRefreshEnabled ? refreshedChildItemStyles : childItemStyles]}
		/>
	);
};
